import enConfig from '@/language/en/main.json';
import zhCnConfig from '@/language/zh-cn/main.json';
import zhHkConfig from '@/language/zh-hk/main.json';
import VueI18n from 'vue-i18n';
import Vue from 'vue';
// 全局挂载VueI18n
Vue.use(VueI18n);


const i18n = new VueI18n({
  locale: 'zh-cn', // 默认显示的语言
  fallbackLocale: 'zh-cn',
  messages: {
    en: enConfig,
    'zh-cn': zhCnConfig,
    'zh-hk': zhHkConfig,
  },
});

export default i18n;
